import { render, staticRenderFns } from "./AdminOrdersResent.vue?vue&type=template&id=348b0999&"
import script from "./AdminOrdersResent.vue?vue&type=script&lang=js&"
export * from "./AdminOrdersResent.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrdersResent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports